import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent implements OnInit {
  // TODO: Part of a cancelation process is already in place here, but for not is not being used.
  @Input() showCancelButton = false;
  @Output() cancel = new EventEmitter<boolean>();
  constructor() {}

  ngOnInit() {}
  cancelLoad(value: boolean) {
    this.cancel.emit(value);
  }
}
